<template>
  <div id="deck-editor">
    <div class="card" v-for="(card, i) in cards" :key="i">
      <input class="name" type="text" v-model="card.name" placeholder="カード名" @keypress.enter.exact="addCard">
      <p><input type="number" min="0" size="1" class="num" v-model.number="card.num" @keypress.enter.exact="addCard"> 枚</p>
      <button @click="removeCard(i)">－</button>
    </div>
    <button @click="addCard">＋</button>
    <p>デッキ枚数：{{deckNum}} 枚</p>
    <p>デッキ枚数 <input type="number" v-model.number="filler"> 枚になるまで <button @click="fillDeck">埋める</button></p>
  </div>
</template>

<style lang="stylus" scoped>
#deck-editor
  display flex
  flex-direction column
  .card
    display grid
    gap 5px
    grid-template-columns 1fr auto auto
    margin-bottom 5px
    align-items stretch
    p
      display flex
      margin 0
      input
        height 100%
        box-sizing border-box
  &>p
    margin 10px 0 0 0
@media (max-width:767px)
  #deck-editor
    .card
      p
        input
          width 3em
</style>

<script>

const Tokens = [
'神龍トークン',
'幻煌龍トークン',
'イービル・トークン',
'冥府の使者カイエントークン',
'ラディアントークン',
'ドッグファイタートークン',
'ナイトメア・デーモン・トークン',
'バトル・イーグル・トークン',
'アスモトークン',
'トリッキートークン',
'エインヘリアル・トークン',
'霊魂鳥トークン',
'コアキメイルトークン',
'サイバネット・トークン',
'サンダーオプショントークン',
'邪神トークン',
'銃士トークン',
'セキュリティトークン',
'ダブルガイ・トークン',
'フォトントークン',
'ブロックトークン',
'兵隊アリトークン',
'ベルキャットトークン',
'マルチプルトークン',
'ムーンライト・トークン',
'Noble Knight Token',
'ギフト・デモン・トークン',
'極星獣トークン',
'クレイジー・ファイヤー・トークン',
'幻獣機トークン',
'シャドウトークン',
'ディウストークン',
'Ｄ・ローズトークン',
'毒蛇トークン',
'イーバトークン',
'イカスミトークン',
'おジャマトークン',
'ガジェット・トークン',
'狐トークン',
'シンクロントークン',
'ＢＦ－ブラック・クレスト・トークン',
'レクンガトークン',
'ローズ・トークン',
'アイヴィトークン',
'アイスコフュントークン',
'古代の歯車トークン',
'アンブラル・ミラージュ・トークン',
'インセクトモンスタートークン',
'インフェルノイドトークン',
'オーバーフロートークン',
'オイスタートークン',
'朧影トークン',
'影武者狸トークン',
'家臣トークン',
'カバートークン',
'巨竜トークン',
'雲魔物トークン',
'水晶機巧トークン',
'クリボートークン',
'クロックトークン',
'黒羊トークン',
'幻影トークン',
'幻魔トークン',
'幻魔の殉教者トークン',
'ゴースト・トークン',
'黒焔トークン',
'仔羊トークン',
'コンジェスタートークン',
'魂魄トークン',
'シードトークン',
'邪眼神トークン',
'邪精トークン',
'ジュラエッグトークン',
'ジュラックトークン',
'人造天使トークン',
'不知火トークン',
'スタッグトークン',
'スチーム・トークン',
'スパイダートークン',
'スピノストークン',
'スプールトークン',
'スライムモンスタートークン',
'星遺物トークン',
'星蝕トークン',
'閃刀姫トークン',
'ソウルトークン',
'電池メントークン',
'タツノコトークン',
'チュウボーンＪｒ.トークン',
'ツクシトークン',
'つぶコーントークン',
'ティンダングルトークン',
'データトークン',
'ＴＧトークン',
'デモンバルサムトークン',
'トーチトークン',
'ドッペル・トークン',
'ドラゴノイドトークン',
'トリックスタートークン',
'ドングルトークン',
'ニードルトークン',
'贄の石碑トークン',
'羊トークン',
'火の玉トークン',
'Ｖ－ＬＡＮトークン',
'プランキッズトークン',
'プラントークン',
'ペンデュラム・トークン',
'魔草トークン',
'ムーントークン',
'メタボトークン',
'メタルデビル・トークン',
'モータートークン',
'ラヴァルトークン',
'リンクトークン',
'レプティレストークン',
'ロックストーン・トークン',
'ワームトークン',
'綿毛トークン',
'ヴェンデットトークン',
'オプショントークン',
'クローントークン',
'決闘竜トークン',
'ダークソウルトークン',
'ミラージュトークン',
'ワルツトークン',
]
function randomToken() {
  return Tokens[Math.floor(Math.random() * Tokens.length)]
}

export default {
  name: 'DeckEditor',
  props: {
    value: {
      type: Array,
      default() { [{name: '', num: 0}] }
    }
  },
  data() {
    return {
      filler: 20,
    }
  },
  computed: {
    cards: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    deckNum() {
      return this.cards.reduce((acc, card) => { return acc + card.num }, 0)
    },
  },
  methods: {
    addCard() {
      this.cards.push({ name: '', num: 0 })
      this.$nextTick(() => {
        let inputs = this.$el.querySelectorAll('input.name')
        if (inputs.length > 0) inputs[inputs.length - 1].focus()
      })
    },
    removeCard(i) {
      this.cards.splice(i, 1)
    },
    getDeck() {
      return this.cards.reduce((acc, card) => {
        if (card.num< 1) return acc
        return [...acc, ...new Array(card.num).fill(card.name)]
      }, [])
    },
    fillDeck() {
      let deckLen = this.getDeck().length
      if (this.filler > deckLen)
        this.cards.push({ name: `--${randomToken()}--`, num: this.filler - deckLen})
    },
  },
}
</script>

